module.exports = __webpack_public_path__ + "img/gold_frame.0d0838a4.png";